import React, { useState, useEffect } from "react";
import "./CrashSettingsModal.scss";
import Popup from "components/ui-kit/Popup/index";
import Button from "components/ui-kit/Button/index";
import {
  ArrowFillUpIcon,
  IconCross,
  LeftFillArrowIcon,
  MusicNoteIcon,
  MuteIcon,
  PlayFillIcon,
  UnMuteIcon,
  MusicNoteMuteIcon,
  UsersFillIcon,
  VolumeFillProfileIcon,
} from "assets/icons/index";
import SwitchButton from "components/ui-kit/SwitchButton/index";
import RangeSlider from "components/ui-kit/RangeSlider/index";
import {
  setGameMusicVolume,
  setGameSoundVolume,
} from "redux-store/redux/slices/gameSettings.slice";
import { useDispatch, useSelector } from "react-redux";
import { formatTime, getPrecision } from "utils/common-functions/index";
import { useTranslation } from "react-i18next";
import { animationVisibility } from "pixi-js-scripts/crash-game/gameManager";
import {
  CURRENCY_SYMBOL,
  DEFAULT_MUSIC_VOLUME,
  DEFAULT_SOUND_VOLUME,
} from "utils/constants/index";

const SUB_SETTINGS = {
  SETTINGS: "Settings",
  LIMITS: "Limits",
  RULES: "Rules",
  MY_BETS: "My Bets",
};

const ACCORDION_VALUES = {
  HOW_TO_PLAY: "HOW_TO_PLAY",
  GAME_DETAILS: "GAME_DETAILS",
  AUTOPLAY: "AUTOPLAY",
  SETTINGS: "SETTINGS",
  DISCONNECTION_POLICY: "DISCONNECTION_POLICY",
  VERSION: "VERSION",
};

const CrashSettingsModal = ({
  gameSetting,
  setIsOpenSettingsModal,
  isOpenSettingsModal,
  handleGameMusicVolume,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { myBetsData } = useSelector((state) => state.crashGame);
  const { currencySymbol, userDetails } = useSelector((state) => state.auth);
  const {
    gameSoundVolume,
    gameMusicVolume,
    previousGameSoundVolume,
    previousGameMusicVolume,
  } = useSelector((state) => state.gameSetting);

  const handleToggleSoundMute = () => {
    if (gameSoundVolume === 0) {
      dispatch(
        setGameSoundVolume(previousGameSoundVolume || DEFAULT_SOUND_VOLUME),
      );
      return;
    }
    dispatch(setGameSoundVolume(0));
  };

  const handleToggleMusicMute = () => {
    if (gameMusicVolume === 0) {
      dispatch(
        setGameMusicVolume(previousGameMusicVolume || DEFAULT_MUSIC_VOLUME),
      );
      return;
    }
    dispatch(setGameMusicVolume(0));
  };
  const [isAccordionToggle, setIsAccordionToggle] = useState(null);
  const [subSettingsToggle, setSubSettingsToggle] = useState(
    SUB_SETTINGS.SETTINGS,
  );
  const [isAnimation, setIsAnimation] = useState(true);

  // Function to handle accordion toggle
  const handleAccordionToggle = (accordionValue) => {
    setIsAccordionToggle((prev) =>
      prev === accordionValue ? null : accordionValue,
    );
  };
  // Reset to default state when modal opens
  useEffect(() => {
    if (isOpenSettingsModal) {
      setSubSettingsToggle(SUB_SETTINGS.SETTINGS);
      setIsAccordionToggle(null);
    }
  }, [isOpenSettingsModal]);

  // Handle modal close - reset state
  const handleCloseModal = () => {
    setIsOpenSettingsModal(false);
  };
  return (
    <>
      <Popup
        className="crash-settings-modal"
        isOpenModal={isOpenSettingsModal}
        handleClose={handleCloseModal}
      >
        <Button
          className="btn-close-modal p-0"
          onClick={() => setIsOpenSettingsModal(false)}
        >
          <div>
            <IconCross fill="var(--secondaryText)" className="close-icon" />
          </div>
        </Button>
        <div className="modal-head d-flex align-items-center">
          {subSettingsToggle !== SUB_SETTINGS.SETTINGS && (
            <LeftFillArrowIcon
              className="m-1 users-head-icon cursor-pointer"
              onClick={() => setSubSettingsToggle(SUB_SETTINGS.SETTINGS)}
            />
          )}
          <div className="settings-modal fw-bolder">{subSettingsToggle}</div>
        </div>
        <div className="content-body">
          {subSettingsToggle === SUB_SETTINGS.SETTINGS && (
            <>
              <div className="users-edit d-flex align-items-center p-2 mb-20">
                <div className="flex-grow-1">
                  <div className="nickname fw-normal">Nickname</div>
                  <div className="recruit fw-bolder">
                    {userDetails?.firstName}
                  </div>
                </div>
                {/* <div className='flex-shrink-0'>
                  <Button
                    className='profile-edit py-0 px-1'
                  >
                    <ProfileEditIcon />
                  </Button>
                </div> */}
              </div>
              <div className="profile-buttons-sectoion">
                <Button
                  className="btn-warning w-100"
                  onClick={() => setSubSettingsToggle(SUB_SETTINGS.LIMITS)}
                >
                  Limits
                </Button>
                <Button
                  className="btn-warning w-100"
                  onClick={() => setSubSettingsToggle(SUB_SETTINGS.RULES)}
                >
                  Rules
                </Button>
                <Button
                  className="btn-warning w-100"
                  onClick={() => setSubSettingsToggle(SUB_SETTINGS.MY_BETS)}
                >
                  My Bets
                </Button>
                {/* <Button className='btn-warning w-100'
              onClick={()=> setSubSettingsToggle('Free_bets')}
            >
              Free Bets
            </Button> */}
              </div>
              <div className="game-settings-section">
                <ul className="game-settings-list list-unstyled mb-0">
                  <li className="d-flex align-items-center mb-1">
                    <div
                      className="svg-icon cursor-pointer"
                      onClick={handleToggleSoundMute}
                    >
                      {gameSoundVolume === 0 ? (
                        <MuteIcon className="w-100" />
                      ) : (
                        <UnMuteIcon className="w-100" />
                      )}
                    </div>

                    <div className="game-volume-setting w-100">
                      <RangeSlider
                        min="0"
                        max="100"
                        value={gameSoundVolume * 100}
                        onChange={(e) => {
                          dispatch(setGameSoundVolume(+e.target.value / 100));
                        }}
                        secondaryBgColor="var(--rangeSliderTrack)"
                      />
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div
                      className="svg-icon cursor-pointer"
                      onClick={handleToggleMusicMute}
                    >
                      {gameMusicVolume === 0 ? (
                        <MusicNoteMuteIcon className="w-100" />
                      ) : (
                        <MusicNoteIcon />
                      )}
                    </div>
                    <div className="game-music-setting w-100">
                      <RangeSlider
                        min="0"
                        max="100"
                        value={gameMusicVolume * 100}
                        onChange={(e) => {
                          dispatch(setGameMusicVolume(+e.target.value / 100));
                        }}
                        secondaryBgColor="var(--rangeSliderTrack)"
                      />
                    </div>
                  </li>
                  <li className="d-flex align-items-center mb-1">
                    <div className="svg-icon">
                      <PlayFillIcon className="" />
                    </div>
                    <div className="game-animation-setting d-flex justify-content-between w-100 align-items-center">
                      Animation
                      <div>
                        <SwitchButton
                          checked={isAnimation}
                          onChange={(e) => {
                            animationVisibility(e.target.checked);
                            setIsAnimation(e.target.checked);
                          }}
                          className="custom-switch secondary-switch"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          )}
          <div className="game-settings-section">
            {subSettingsToggle === SUB_SETTINGS.LIMITS && (
              <>
                {/* Limits content section  */}
                <div className="limit-settings pb-3">
                  <div className="users-edit p-2 mb-2">
                    <div className="limits-label">Min bet</div>
                    <div className="limits-value">
                      {currencySymbol} {gameSetting?.minBetData}
                    </div>
                  </div>
                  <div className="users-edit p-2 mb-2">
                    <div className="limits-label">Max bet</div>
                    <div className="limits-value">
                      {currencySymbol} {gameSetting?.maxBetData}
                    </div>
                  </div>
                  <div className="users-edit p-2 mb-2">
                    <div className="limits-label">Max profit</div>
                    <div className="limits-value">
                      {currencySymbol} {gameSetting?.maxProfitData}
                    </div>
                  </div>
                </div>
              </>
            )}
            {subSettingsToggle === SUB_SETTINGS.RULES && (
              <>
                {/* Rules content section  */}
                <div className="rules-settings pb-3">
                  {/* How to play */}
                  <div
                    className={`accordion mb-2 ${isAccordionToggle === ACCORDION_VALUES.HOW_TO_PLAY ? "active" : "active"}`}
                  >
                    <div className="d-flex align-items-center p-2 text-white">
                      <div className="fw-bold accordion-title">
                        How to play?
                      </div>

                      {/*
  <ArrowFillUpIcon
    className='accordion-arrow cursor-pointer'
    id='accordion_play'
    onClick={() => handleAccordionToggle(ACCORDION_VALUES.HOW_TO_PLAY)}
  />
  */}
                    </div>

                    <div className="accordion-content active">
                      <div className="p-2">
                        <ul className="fw-bold text-white ps-4">
                          <li className="mb-2">
                            Place your bet before the plane takes off
                          </li>
                          <li className="mb-2">
                            Take your chance and wait until multiplier reach
                            your desired goal
                          </li>
                          <li className="mb-2">
                            Cash out before the plane flies away!
                          </li>
                        </ul>
                        <p className="fw-bold text-white mb-0">
                          The longer you stay in the game, the higher payoff you
                          will get. Please be noted that the plane may fly away
                          at any moment. If you fail to cash out on time, you
                          will lose the bet.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Game details
  <div className={`accordion mb-2 ${isAccordionToggle === ACCORDION_VALUES.GAME_DETAILS ? 'active' : ''}`}>
    ...
  </div>
  */}

                  {/* Autoplay
  <div className={`accordion mb-2 ${isAccordionToggle === ACCORDION_VALUES.AUTOPLAY ? 'active' : ''}`}>
    ...
  </div>
  */}
                </div>
              </>
            )}
            {subSettingsToggle === SUB_SETTINGS.MY_BETS && (
              <>
                {/* my-bet content section  */}
                <table className="table text-white table-borderless mb-0 my-bets-table">
                  <thead>
                    <tr>
                      <th>Time</th>
                      <th className="text-center">Multiple</th>
                      <th className="text-end">Payout</th>
                    </tr>
                  </thead>
                </table>
                <div className="my-bet-settings mb-3">
                  <table className="table text-white table-borderless mb-0 my-bets-table">
                    <tbody>
                      {myBetsData?.rows?.length ? (
                        myBetsData?.rows?.map((data) => {
                          const currencySymbol =
                            CURRENCY_SYMBOL[data?.currency?.code] || "$";
                          const escapeRate = getPrecision(data?.escapeRate);
                          const winningAmount = getPrecision(
                            data?.winningAmount,
                          );
                          return (
                            <tr key={data?.id.toString()}>
                              <td>{formatTime(data?.createdAt)}</td>
                              <td className="text-start text-green-900">
                                {escapeRate === 0 ? "--" : `${escapeRate}x`}
                              </td>
                              <td className="text-green-900 text-end">
                                {winningAmount > 0 ? "+" : ""}
                                {currencySymbol}
                                {winningAmount.toFixed(2)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr className="text-center">
                          <td colSpan="6">{t("noData")}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </Popup>
    </>
  );
};
export default CrashSettingsModal;
